import {HttpClientModule} from "@angular/common/http";
import {NgModule} from "@angular/core";
import {MomentModule} from "angular2-moment";
import {IonicModule} from "ionic-angular";
import {Loader} from "./loader/loader";
import {ValidationMessagesComponent} from './validation-messages/validation-messages';

@NgModule({
  declarations: [
    Loader,
    ValidationMessagesComponent
  ],
  imports: [
    IonicModule,
  ],
  exports: [
    IonicModule,
    HttpClientModule,
    MomentModule,
    Loader,
    ValidationMessagesComponent
  ],
})
export class ComponentsModule {
}



// WEBPACK FOOTER //
// ./src/components/components.module.ts